import { render } from "./CommonModal.vue?vue&type=template&id=618810ab&scoped=true"
import script from "./CommonModal.vue?vue&type=script&lang=js"
export * from "./CommonModal.vue?vue&type=script&lang=js"

import "./CommonModal.vue?vue&type=style&index=0&id=618810ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618810ab"]])

export default __exports__